import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import galleryData from "../data/gallery"; // data offline galeri

function Gallery() {
  return (
    <>
      <Navbar />

      <div className="container mx-auto px-20">
        <div className="mt-6 mb-6">
          <h2 className="text-2xl font-semibold mb-8">Gallery</h2>

          <div className="py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {galleryData.map((item) => (
              <div
                key={item.id}
                className="border rounded overflow-hidden shadow hover:shadow-lg transition"
              >
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img
                    src={item.image_url}
                    alt={item.caption}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-3 bg-gray-50 text-center text-sm font-medium">
                    {item.caption}
                    <br />
                    {item.location}, {item.date}
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Gallery;
